// instantTuneService.js
import apiClient from './apiClient.ts';
import { CreateTuneUploadIn } from '../types/createTuneUpload.ts';

export const createTuneUpload = async (tunes: CreateTuneUploadIn[]) => {
  console.log(tunes)
  const response = await apiClient.post('/tune-ops', tunes);
  return response.data;
};

export const getUserTunesHistory = async (page = 1, limit = 10, filters = {}) => {
  const params = {
    page: Number(page),
    limit: Number(limit),
    ...filters, // adds start_date, end_date, executed if provided
  };

  const response = await apiClient.get('/tune-ops', { params });
  return response.data;
};
